import { LineChartUp02, Status } from "@alch/ui/icons/16";
import { Path } from "@util/paths";
import { InAppNotificationType } from "@webapp/shared";

export const notifConfig: Record<
  InAppNotificationType,
  {
    icon: React.FunctionComponent<React.ComponentProps<"svg">>;
    actionLabel: string;
    actionLink: string;
  }
> = {
  [InAppNotificationType.UsageAlert]: {
    icon: LineChartUp02,
    actionLabel: "View usage",
    actionLink: Path.Usage,
  },
  [InAppNotificationType.ErrorAlert]: {
    icon: Status,
    actionLabel: "View Logs",
    actionLink: `${Path.Logs}?errors=1`,
  },
};
